import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { McommerceTripDetailCartAuditDialogComponent } from 'src/app/components/mcommerce-components/mcommerce-trip-detail-cart-audit-dialog/mcommerce-trip-detail-cart-audit-dialog.component';
import { McommerceTripDetailCartCancelPurchaseDialogComponent } from 'src/app/components/mcommerce-components/mcommerce-trip-detail-cart-cancel-purchase-dialog/mcommerce-trip-detail-cart-cancel-purchase-dialog.component';

@Component({
  selector: 'app-mcommerce-trip-card',
  templateUrl: './mcommerce-trip-card.component.html',
  styleUrls: ['./mcommerce-trip-card.component.scss']
})
export class McommerceTripCardComponent implements OnInit {

  @Input() trip;

  constructor(private router: Router,
              public dialog: MatDialog) { }

  ngOnInit() {
  }

  public gotoDetail() {
    this.router.navigate(['mcommerce/trip', this.trip.id]);
  }

  public gotoAudit() {
    this.dialog.open(McommerceTripDetailCartAuditDialogComponent);
  }

  public cancelPurchase() {
    this.dialog.open(McommerceTripDetailCartCancelPurchaseDialogComponent);
  }
}
